const locationToString = (location: {
  city?: string;
  state?: string;
  country?: string;
}): string => {
  switch (location.state) {
    case "England":
      return `🏴󠁧󠁢󠁥󠁮󠁧󠁿 ${location.city}`;

    case "Scotland":
      return `🏴󠁧󠁢󠁳󠁣󠁴󠁿 ${location.city}`;

    case "Wales":
      return `🏴󠁧󠁢󠁷󠁬󠁳󠁿 ${location.city}`;

    default:
      return `${(location.country || "")
        .toUpperCase()
        .replace(/./g, (char) =>
          String.fromCodePoint(char.charCodeAt(0) + 127397)
        )} ${location.city}`;
  }
};

export default locationToString;
